import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

const BuyerPrivateRoute = () => {
  const { user, loading, profileLoading, userProfile } = useAuth();

  if (loading || profileLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/comprador/login" replace />;
  }

  if (userProfile && userProfile.isBuyer !== true) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default BuyerPrivateRoute;
